import React from 'react';
import { NavLink } from 'react-router-dom';

const NotAuthorized = () => {
    return (
        <main>
        <section className="home-link-container">
        <h1 className="error-heading">Accès non autorisé</h1>
        <p className='authorization-text'>Vous n'êtes pas autorisé à accéder à cette page. Veuillez vous connecter.</p>
        <NavLink to="/" className="home-link">
          Retour à la page d'accueil
        </NavLink>
      </section>
      </main>
    );
};

export default NotAuthorized;